// Pagination.js
import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({
    totalCount,
    currentPage,
    pageSize,
    onPageChange
}) => {
    const totalPages = Math.ceil(totalCount / pageSize);

    const getDisplayedPageNumbers = () => {
        const pageNumbers = [];
        if (totalPages <= 3) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            if (currentPage === 1) {
                pageNumbers.push(1, 2, 3);
            } else if (currentPage === totalPages) {
                pageNumbers.push(totalPages - 2, totalPages - 1, totalPages);
            } else {
                pageNumbers.push(currentPage - 1, currentPage, currentPage + 1);
            }
        }
        return pageNumbers;
    };

    return (
        <div>
            <span>
                Showing {(currentPage - 1) * pageSize + 1} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} entries
            </span>

            <Pagination className="float-right">
                {currentPage > 1 && (
                    <>
                        <Pagination.First onClick={() => onPageChange(1)}>First</Pagination.First>
                        <Pagination.Prev onClick={() => onPageChange(currentPage - 1)}>Previous</Pagination.Prev>
                    </>
                )}
                {getDisplayedPageNumbers().map((pageNumber) => (
                    <Pagination.Item
                        key={pageNumber}
                        active={pageNumber === currentPage}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </Pagination.Item>
                ))}
                {currentPage < totalPages && (
                    <>
                        <Pagination.Next onClick={() => onPageChange(currentPage + 1)}>Next</Pagination.Next>
                        <Pagination.Last onClick={() => onPageChange(totalPages)}>Last</Pagination.Last>
                    </>
                )}
            </Pagination>
        </div>
    );
};

export default CustomPagination;
